import { RadioGroup } from '@anyui/core';
import { cn } from '@anytag/shared-utils';
import { Radio } from '@anytag/shared-atoms';
import { HighChart } from '@anytag/shared-molecules';
import { TikTokSpecialCampaignChartReport } from '@anytag/graphql';
import { TikTokCampaignReportOption } from './types';
import { useTikTokCampaignReportChart } from './hooks';

export interface TikTokCampaignReportChartProps {
  className?: string;
  data?: readonly TikTokSpecialCampaignChartReport[];
}

export const TikTokCampaignReportChart = ({ data, className }: TikTokCampaignReportChartProps) => {
  const { allMetrics, chartOptions, selectedMetric, setSelectedMetric } = useTikTokCampaignReportChart({ data });

  if (!data) {
    return null;
  }

  return (
    <div className={cn('border-t-border bg-white', className)}>
      <RadioGroup
        value={selectedMetric}
        onChange={(value) => setSelectedMetric(value as TikTokCampaignReportOption['value'])}
      >
        <div className="box-border flex flex-wrap gap-x-2 gap-y-4 px-4 py-6">
          {Object.values(allMetrics).map((item) => (
            <Radio
              key={item.value}
              value={item.value}
              className="box-border cursor-pointer rounded-sm border-base-border p-1"
              label={
                <div className="flex items-center gap-1">
                  <span>{item.label}</span>
                  <span className="size-2 rounded-xs" style={{ backgroundColor: item.color }} />
                </div>
              }
            />
          ))}
        </div>
      </RadioGroup>

      <HighChart options={chartOptions} />
    </div>
  );
};
